'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _PageDescription = require('./PageDescription.component');

var _PageDescription2 = _interopRequireDefault(_PageDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArrowButton = function (_BcReactComponent) {
  _inherits(ArrowButton, _BcReactComponent);

  function ArrowButton() {
    _classCallCheck(this, ArrowButton);

    return _possibleConstructorReturn(this, (ArrowButton.__proto__ || Object.getPrototypeOf(ArrowButton)).apply(this, arguments));
  }

  _createClass(ArrowButton, [{
    key: 'focus',
    value: function focus() {
      this._button.focus();
    }
  }, {
    key: 'getTargetPage',
    value: function getTargetPage() {
      return this.props.direction === 'left' ? this.props.currentPage - 1 : this.props.currentPage + 1;
    }
  }, {
    key: 'renderArrow',
    value: function renderArrow() {
      return this.props.direction === 'left' ? _react2.default.createElement(_baseIcons.Chevron.Left, null) : _react2.default.createElement(_baseIcons.Chevron.Right, null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          handleClick = _props.handleClick,
          pageSize = _props.pageSize,
          numberOfItems = _props.numberOfItems,
          props = _objectWithoutProperties(_props, ['className', 'disabled', 'handleClick', 'pageSize', 'numberOfItems']);

      return _react2.default.createElement(
        _baseButtons.Button,
        _extends({}, props, {
          ref: function ref(el) {
            return _this2._button = el;
          },
          className: 'cp-arrow-button ' + className,
          disabled: disabled,
          handleClick: handleClick }),
        _react2.default.createElement(_PageDescription2.default, {
          page: this.getTargetPage(),
          pageSize: pageSize,
          numberOfItems: numberOfItems }),
        this.renderArrow()
      );
    }
  }]);

  return ArrowButton;
}(_baseBcReactComponent2.default);

exports.default = ArrowButton;


ArrowButton.propTypes = {
  currentPage: _react.PropTypes.number,
  className: _react.PropTypes.string,
  pageSize: _react.PropTypes.number,
  numberOfItems: _react.PropTypes.number,
  direction: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  handleClick: _react.PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/carousel/base-carousel/lib/components/ArrowButton.component.js
// module id = 478
// module chunks = 3 5 6 7